// extracted by mini-css-extract-plugin
export var audioPlayer = "_ov-0";